module.exports = __webpack_public_path__ + "img/tableroGps.17580407.webp";